"use strict";

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecretLockInfoBuilder = void 0;

var AddressDto_1 = require("./AddressDto");

var GeneratorUtils_1 = require("./GeneratorUtils");

var Hash256Dto_1 = require("./Hash256Dto");

var HeightDto_1 = require("./HeightDto");

var MosaicBuilder_1 = require("./MosaicBuilder");

var StateHeaderBuilder_1 = require("./StateHeaderBuilder");

var SecretLockInfoBuilder = /*#__PURE__*/function (_StateHeaderBuilder_) {
  _inherits(SecretLockInfoBuilder, _StateHeaderBuilder_);

  var _super = _createSuper(SecretLockInfoBuilder);

  function SecretLockInfoBuilder(version, ownerAddress, mosaic, endHeight, status, hashAlgorithm, secret, recipient) {
    var _this;

    _classCallCheck(this, SecretLockInfoBuilder);

    _this = _super.call(this, version);
    GeneratorUtils_1.GeneratorUtils.notNull(ownerAddress, 'ownerAddress is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(mosaic, 'mosaic is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(endHeight, 'endHeight is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(status, 'status is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(hashAlgorithm, 'hashAlgorithm is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(secret, 'secret is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(recipient, 'recipient is null or undefined');
    _this.ownerAddress = ownerAddress;
    _this.mosaic = mosaic;
    _this.endHeight = endHeight;
    _this.status = status;
    _this.hashAlgorithm = hashAlgorithm;
    _this.secret = secret;
    _this.recipient = recipient;
    return _this;
  }

  _createClass(SecretLockInfoBuilder, [{
    key: "getOwnerAddress",
    value: function getOwnerAddress() {
      return this.ownerAddress;
    }
  }, {
    key: "getMosaic",
    value: function getMosaic() {
      return this.mosaic;
    }
  }, {
    key: "getEndHeight",
    value: function getEndHeight() {
      return this.endHeight;
    }
  }, {
    key: "getStatus",
    value: function getStatus() {
      return this.status;
    }
  }, {
    key: "getHashAlgorithm",
    value: function getHashAlgorithm() {
      return this.hashAlgorithm;
    }
  }, {
    key: "getSecret",
    value: function getSecret() {
      return this.secret;
    }
  }, {
    key: "getRecipient",
    value: function getRecipient() {
      return this.recipient;
    }
  }, {
    key: "getSize",
    value: function getSize() {
      var size = _get(_getPrototypeOf(SecretLockInfoBuilder.prototype), "getSize", this).call(this);

      size += this.ownerAddress.getSize();
      size += this.mosaic.getSize();
      size += this.endHeight.getSize();
      size += 1;
      size += 1;
      size += this.secret.getSize();
      size += this.recipient.getSize();
      return size;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var newArray = Uint8Array.from([]);

      var superBytes = _get(_getPrototypeOf(SecretLockInfoBuilder.prototype), "serialize", this).call(this);

      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, superBytes);
      var ownerAddressBytes = this.ownerAddress.serialize();
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, ownerAddressBytes);
      var mosaicBytes = this.mosaic.serialize();
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, mosaicBytes);
      var endHeightBytes = this.endHeight.serialize();
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, endHeightBytes);
      var statusBytes = GeneratorUtils_1.GeneratorUtils.uint8ToBuffer(this.status);
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, statusBytes);
      var hashAlgorithmBytes = GeneratorUtils_1.GeneratorUtils.uint8ToBuffer(this.hashAlgorithm);
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, hashAlgorithmBytes);
      var secretBytes = this.secret.serialize();
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, secretBytes);
      var recipientBytes = this.recipient.serialize();
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, recipientBytes);
      return newArray;
    }
  }], [{
    key: "loadFromBinary",
    value: function loadFromBinary(payload) {
      var byteArray = Array.from(payload);
      var superObject = StateHeaderBuilder_1.StateHeaderBuilder.loadFromBinary(payload);
      byteArray.splice(0, superObject.getSize());
      var ownerAddress = AddressDto_1.AddressDto.loadFromBinary(Uint8Array.from(byteArray));
      byteArray.splice(0, ownerAddress.getSize());
      var mosaic = MosaicBuilder_1.MosaicBuilder.loadFromBinary(Uint8Array.from(byteArray));
      byteArray.splice(0, mosaic.getSize());
      var endHeight = HeightDto_1.HeightDto.loadFromBinary(Uint8Array.from(byteArray));
      byteArray.splice(0, endHeight.getSize());
      var status = GeneratorUtils_1.GeneratorUtils.bufferToUint8(Uint8Array.from(byteArray));
      byteArray.splice(0, 1);
      var hashAlgorithm = GeneratorUtils_1.GeneratorUtils.bufferToUint8(Uint8Array.from(byteArray));
      byteArray.splice(0, 1);
      var secret = Hash256Dto_1.Hash256Dto.loadFromBinary(Uint8Array.from(byteArray));
      byteArray.splice(0, secret.getSize());
      var recipient = AddressDto_1.AddressDto.loadFromBinary(Uint8Array.from(byteArray));
      byteArray.splice(0, recipient.getSize());
      return new SecretLockInfoBuilder(superObject.version, ownerAddress, mosaic, endHeight, status, hashAlgorithm, secret, recipient);
    }
  }, {
    key: "createSecretLockInfoBuilder",
    value: function createSecretLockInfoBuilder(version, ownerAddress, mosaic, endHeight, status, hashAlgorithm, secret, recipient) {
      return new SecretLockInfoBuilder(version, ownerAddress, mosaic, endHeight, status, hashAlgorithm, secret, recipient);
    }
  }]);

  return SecretLockInfoBuilder;
}(StateHeaderBuilder_1.StateHeaderBuilder);

exports.SecretLockInfoBuilder = SecretLockInfoBuilder;